import React, { Component } from "react";

import { CButton, CCol, CProgress, CRow, CSelect } from "@coreui/react";
import { Label } from "reactstrap";

import "./styles.scss";
import {
  arrayToCSV,
  elementToPDF,
  arrayToXLSX,
  arrayToXLS
} from "../../../utils/export";
import getStudentsData from "../DataFromBackend/StudentsData";

class estatisticasTurma extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo: "0",
      disciplina: "0",
      professor: "0"
    };
  }

  render() {
    const { professor, disciplina, tipo } = this.state;

    const tipos = this.props.room.filter(
      (v, i, a) =>
        a.findIndex(item => item.activity.type_id === v.activity.type_id) ===
          i && v.activity.type_id !== 2
    );
    const disciplinas = this.props.room.filter(
      (v, i, a) =>
        a.findIndex(
          item => item.activity.discipline_id === v.activity.discipline_id
        ) === i && v.activity.discipline_id
    );
    const professores = this.props.room.filter(
      (v, i, a) =>
        a.findIndex(item => item.activity.user_id === v.activity.user_id) ===
          i && v.activity.user_id
    );

    const activities = this.props.room.filter(
      activity =>
        activity.activity.type_id !== 2 &&
        (!parseInt(tipo) || activity.activity.type_id === parseInt(tipo)) &&
        (!parseInt(disciplina) ||
          activity.activity.discipline_id === parseInt(disciplina)) &&
        (!parseInt(professor) ||
          activity.activity.user_id === parseInt(professor))
    );

    const calculatePercent = activity => {
      const trulyExecutions = activity.executions.filter(
        execution => execution.completion_percentage >= 100
      );

      return (trulyExecutions.length / activity.users.length) * 100;
    };

    const majorMinorAverageGrade = (activity, operation) => {
      const gradeExecutions = activity.executions.filter(
        execution => execution.grade !== null
      );

      if (operation === "major") {
        return gradeExecutions.length > 0
          ? gradeExecutions
              .reduce((acc, val) => Math.max(acc, parseFloat(val.grade)), 0)
              .toFixed(2)
          : "";
      }
      if (operation === "minor") {
        return gradeExecutions.length > 0
          ? gradeExecutions
              .reduce((acc, val) => Math.min(acc, parseFloat(val.grade)), 10000)
              .toFixed(2)
          : "";
      }
      return gradeExecutions.length > 0
        ? (
            gradeExecutions.reduce(
              (acc, val) => acc + parseFloat(val.grade),
              0
            ) / gradeExecutions.length
          ).toFixed(2)
        : "";
    };

    const getArray = data => {
      const header = [
        "atividade",
        "tipo de atividade",
        "disciplina",
        "professor",
        "alunos",
        "% conclusão",
        "maior nota",
        "menor nota",
        "média"
      ];

      const arr = [header];

      data.forEach((item, index) => {
        arr.push([
          item.activity.name,
          item.activity.type_name,
          item.activity.discipline_name,
          item.activity.author,
          item.users.length,
          `${calculatePercent(item)}%`,
          majorMinorAverageGrade(item, "major"),
          majorMinorAverageGrade(item, "minor"),
          majorMinorAverageGrade(item, "average")
        ]);
      });

      return arr;
    };

    return (
      <div className="layoutTabela flex-column">
        <CRow className="mb-4">
          <CCol>
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Tipo</Label>
            </div>
            <CSelect
              value={tipo}
              onChange={e => this.setState({ tipo: e.target.value })}
            >
              <option value={0}>Todos os tipos</option>
              {tipos.map(tipo => (
                <option value={tipo.activity.type_id}>
                  {tipo.activity.type_name}
                </option>
              ))}
            </CSelect>
          </CCol>
          <CCol>
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Disciplina</Label>
            </div>
            <CSelect
              value={disciplina}
              onChange={e => this.setState({ disciplina: e.target.value })}
            >
              <option value={0}>Todas as disciplinas</option>
              {disciplinas.map(disciplina => (
                <option value={disciplina.activity.discipline_id}>
                  {disciplina.activity.discipline_name}
                </option>
              ))}
            </CSelect>
          </CCol>
          <CCol>
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Professores</Label>
            </div>
            <CSelect
              value={professor}
              onChange={e => this.setState({ professor: e.target.value })}
            >
              <option value={0}>Todos os professores</option>
              {professores.map(professor => (
                <option value={professor.activity.user_id}>
                  {professor.activity.user_name}
                </option>
              ))}
            </CSelect>
          </CCol>
          {activities.length && (
            <div className="d-flex w-100 justify-content-end mt-3 mt-4 pr-3 est-export-bar">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToXLSX(
                    getArray(activities),
                    "Estatísticas da turma por atividade.xlsx"
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLSX
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToXLS(
                    getArray(activities),
                    "Estatísticas da turma por atividade.xls"
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLS
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToCSV(
                    getArray(activities),
                    "Estatísticas da turma por atividade.csv"
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para CSV
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  elementToPDF(
                    "list",
                    "Estatísticas da turma por atividade.pdf"
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
              </CButton>
            </div>
          )}
        </CRow>
        {/* Em tela estreita a tabela rola na horizontal dentro do modal
            (Classroom/Show/styles.css). Antes ficava escondida abaixo de 576px
            (d-none d-sm-table) e o celular não via dado nenhum. */}
        <table className="table table-hover table-outline mb-0" id="list">
          <thead className="thead-light">
            <tr>
              <th>Atividade</th>
              <th>Tipo de atividade</th>
              <th>Disciplina</th>
              <th>Professor</th>
              <th>Estudantes</th>
              <th>% Conclusão</th>
              <th>Maior nota</th>
              <th>Menor nota</th>
              <th>Média</th>
            </tr>
          </thead>
          <tbody>
            {activities.map(activity => {
              const trulyExecutions = activity.executions.filter(
                execution => execution.completion_percentage >= 100
              );

              const gradeExecutions = activity.executions.filter(
                execution => execution.grade !== null
              );

              const trulyApplications = getStudentsData(activity.applications);

              return (
                <tr key={activity.id}>
                  <td>{activity.activity.name}</td>
                  <td>{activity.activity.type_name}</td>
                  <td>{activity.activity.discipline_name}</td>
                  <td>{activity.activity.user_name}</td>
                  <td>{activity.users.length}</td>
                  <td>
                    <div className="clearfix">
                      <div className="float-left">
                        <strong>
                          {(
                            (trulyExecutions.length / activity.users.length) *
                            100
                          ).toFixed(2)}
                          %
                        </strong>
                      </div>
                    </div>
                    <CProgress
                      className="progress-xs"
                      color={
                        (trulyExecutions.length / activity.users.length) * 100 >
                        50
                          ? "success"
                          : (trulyExecutions.length / activity.users.length) *
                              100 <=
                              50 &&
                            (trulyExecutions.length / activity.users.length) *
                              100 >=
                              30
                          ? "warning"
                          : "danger"
                      }
                      value={
                        (trulyExecutions.length / activity.users.length) * 100
                      }
                    />
                  </td>
                  <td>
                    {gradeExecutions.length > 0
                      ? gradeExecutions
                          .reduce(
                            (acc, val) => Math.max(acc, parseFloat(val.grade)),
                            0
                          )
                          .toFixed(2)
                      : ""}
                  </td>
                  <td>
                    {gradeExecutions.length > 0
                      ? gradeExecutions
                          .reduce(
                            (acc, val) => Math.min(acc, parseFloat(val.grade)),
                            10000
                          )
                          .toFixed(2)
                      : ""}
                  </td>
                  <td>
                    {gradeExecutions.length > 0
                      ? (
                          gradeExecutions.reduce(
                            (acc, val) => acc + parseFloat(val.grade),
                            0
                          ) / gradeExecutions.length
                        ).toFixed(2)
                      : ""}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      /* <div id="lista-atividades">
        <div id="atividade1">
          <table className="tabela-estatisticas-turma">
            <thead>
              <th>Atividade</th>
              <th>Total de alunos</th>
              <th>Quantos concluíram</th>
              <th>% que concluiu</th>
              <th>Quantos faltam concluir</th>
              <th>% quantos faltam concluir</th>
              <th>Maior nota</th>
              <th>Menor nota</th>
              <th>Média</th>
            </thead>
            <tbody>
              {this.props.room.map(activity => {
                const trulyExecutions = activity.executions.filter(
                  (execution) => execution.completion_percentage >= 100
                );
                const trulyApplications = getStudentsData(activity.applications);

                return (
                  <tr key={activity.id}>
                    <td>{activity.activity.name}</td>
                    <td>{activity.users.length}</td>
                    <td>{trulyExecutions.length}</td>
                    <td>{(trulyExecutions.length / activity.users.length) * 100}%</td>
                    <td>{activity.users.length - trulyExecutions.length}</td>
                    <td>{100 - (trulyExecutions.length / activity.users.length) * 100}%</td>
                    <td>{activity.applications.length > 0
                      ? trulyApplications
                          .reduce(
                            (acc, val) => Math.max(acc, parseFloat(val.nota)),
                            0
                          )
                          .toFixed(2)
                      : ""}
                    </td>
                    <td>{activity.applications.length > 0
                      ? trulyApplications
                          .reduce(
                            (acc, val) => Math.min(acc, parseFloat(val.nota)),
                            10000
                          )
                          .toFixed(2)
                      : ""}
                    </td>
                    <td>{activity.applications.length > 0
                      ? (
                          trulyApplications.reduce(
                            (acc, val) => acc + parseFloat(val.nota),
                            0
                          ) / trulyApplications.length
                        ).toFixed(2)
                      : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div> */
    );
  }
}

export default estatisticasTurma;
